module.exports = __webpack_public_path__ + "static/media/student34.4c73ef62.png";